import React, { isValidElement } from 'react'

import { v4 as uuidv4 } from 'uuid'
export type TokenCreator = (result: RegExpMatchArray) => React.ReactNode
export type Tokenizer = {
  regex: RegExp
  toToken: TokenCreator
}

const isString = (...items: unknown[]) => items.every(i => typeof i === 'string')

export const createTokenizer = (tokenizers: Tokenizer[]) => (nodes: unknown[]) => {
  const join = (arr: string[], value: unknown) => {
    return arr.reduce((list, item, index) => {
      if (index !== arr.length - 1) {
        if (isString(item, value)) {
          return [...list, item + value]
        }
        return [...list, item, value]
      }
      return [...list, item]
    }, [] as unknown[])
  }
  tokenizers.forEach(tokenizer => {
    nodes = nodes.reduce((set: unknown[], node: unknown) => {
      if (typeof node === 'string' && tokenizer.regex.test(node)) {
        const result = tokenizer.regex.exec(node)
        if (result != null) {
          const token = tokenizer.toToken(result)

          return [...set, ...createTokenizer(tokenizers)(join(node.split(result[0]), token))]
        }
      }

      return [...set, node]
    }, [])
  })
  // merge back the strings if two strings are adjacent
  return nodes.reduce((set: unknown[], item: unknown, index) => {
    let processedItem = item
    if (isValidElement(item)) {
      processedItem = React.cloneElement(item, { key: uuidv4() })
    }

    if (index === 0) {
      set = [processedItem]
    } else if (isString(set[set.length - 1], processedItem)) {
      set[set.length - 1] += processedItem as string
    } else {
      set = [...set, processedItem]
    }
    return set
  }, []) as React.ReactNode[]
}
